module.exports = __webpack_public_path__ + "static/media/roehling.1a3314fc.jpg";